import React from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-Q3X8LKX6GF';

export default function useAnalyticsPageTracking() {
    const location = useLocation();

    React.useEffect(() => {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
            return;
        }

        // Collect UTM params from sessionStorage if present
        const utmKeys = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
        ];
        const utmParams = {};
        utmKeys.forEach((key) => {
            const value = window.sessionStorage.getItem(key);
            if (value !== null) {
                utmParams[key] = value;
            }
        });
        // Optionally include the original landing URL with UTMs
        const utmLandingUrl = window.sessionStorage.getItem('utm_landing_url');
        if (utmLandingUrl) {
            utmParams['utm_landing_url'] = utmLandingUrl;
        }
        window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
            send_to: GA_MEASUREMENT_ID,
            ...utmParams,
        });
    }, [location.pathname, location.search]);
}